var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarageDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8f8f8f",
    "data-name": "13-Garage",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m60 61h-56a1 1 0 0 1-1-1v-37h2v36h54v-36h2v37a1 1 0 0 1-1 1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m63 26a1 1 0 0 1 -.458-.111l-30.542-15.764-30.542 15.764a1 1 0 0 1 -1.458-.889v-5a1 1 0 0 1 .542-.889l31-16a1 1 0 0 1 .916 0l31 16a1 1 0 0 1 .542.889v5a1 1 0 0 1 -1 1zm-31-18a1 1 0 0 1 .458.111l29.542 15.247v-2.749l-30-15.484-30 15.484v2.749l29.542-15.247a1 1 0 0 1 .458-.111z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m53 61h-42a1 1 0 0 1-1-1v-32a3 3 0 0 1 3-3h38a3 3 0 0 1 3 3v32a1 1 0 0 1-1 1zm-41-2h40v-31a1 1 0 0 0-1-1h-38a1 1 0 0 0-1 1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m4 53h7v2h-7z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m53 53h7v2h-7z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m42 33h11v2h-11z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m38 33h2v2h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m11 33h25v2h-25z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m11 37h42v2h-42z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m11 29h42v2h-42z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m44 57h-24a1 1 0 0 1-1-1v-4a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1zm-23-2h22v-3a1 1 0 0 0-1-1h-20a1 1 0 0 0-1 1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m40.014 50.164-.722-4.329a1 1 0 0 0 -.986-.835h-12.612a1 1 0 0 0 -.986.835l-.722 4.329-1.972-.328.721-4.329a2.991 2.991 0 0 1 2.959-2.507h12.612a2.991 2.991 0 0 1 2.959 2.507l.721 4.329z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m25 61h-4a1 1 0 0 1-1-1v-4h2v3h2v-3h2v4a1 1 0 0 1-1 1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m43 61h-4a1 1 0 0 1-1-1v-4h2v3h2v-3h2v4a1 1 0 0 1-1 1z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m22 52h2v2h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m40 52h2v2h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m26 50h2v6h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m36 50h2v6h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m27 52h10v2h-10z",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageDisabled);
export default __webpack_public_path__ + "static/media/garage_disabled.11b2ca870cd87a27810dd822275158b0.svg";
export { ForwardRef as ReactComponent };